import React from 'react';
import PropTypes from 'prop-types';
import BulletPointList from '../../../components/sso/components/common/utility/BulletPointList';
import { getMultilineText } from '../utils';

function BasketDialogBoxContentBody({
    basketDialogBoxTitle,
    basketDialogBoxMessage,
    basketDialogBoxLogo
}) {
    const basketDialogBoxMessageSplit = getMultilineText(basketDialogBoxMessage);
    const hasBoxTitle = basketDialogBoxTitle !== '' && basketDialogBoxTitle !== null;
    const hasBoxLogo = basketDialogBoxLogo !== null || basketDialogBoxLogo !== undefined;
    return (
        <div className="basket-popup-container">
            {hasBoxLogo &&
                <img src={basketDialogBoxLogo} className="basket-popup-box-logo"></img>
            }
            {hasBoxTitle &&
                <h2 className="title field-header-title">{basketDialogBoxTitle}</h2>
            }
            <div className='fs-14 field-header-text'>
                <BulletPointList listItems={basketDialogBoxMessageSplit}></BulletPointList>
            </div>
            <div className={'form-field auto-mt-xs leaveOneClubCheck-field'}></div>
            <br />
        </div>
    );
}

BasketDialogBoxContentBody.propTypes = {
    basketDialogBoxTitle: PropTypes.string,
    basketDialogBoxMessage: PropTypes.string
};

export default BasketDialogBoxContentBody;
